import { CaretDownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { FEEDBACK_COLUMNS } from '@/types/filterKeyConst';

type FooterProps = {
  onSelectAll: () => void;
  onDeselectAll: () => void;
  filterOption: FilterOptionT | null;
  onLevelSelect: (level: number) => void;
};

const allowLevelFilterList = [
  FEEDBACK_COLUMNS.TAXONOMY_TOPIC,
  FEEDBACK_COLUMNS.TAG,
];

export enum TOPIC_LEVEL_FILTER {
  LEVEL1 = 1,
  LEVEL2,
  LEVEL3,
  LEVEL4,
}

export const TopicLevelFilterArr = [
  TOPIC_LEVEL_FILTER.LEVEL1,
  TOPIC_LEVEL_FILTER.LEVEL2,
  TOPIC_LEVEL_FILTER.LEVEL3,
  TOPIC_LEVEL_FILTER.LEVEL4,
];

const AllSelectFooter = (props: FooterProps) => {
  const color = useColor();
  return (
    <Flex g={8} j="flex-end" padding="8px">
      <Button variant="outlined" onClick={props.onSelectAll} sizeType="m">
        Select All
      </Button>
      <Button variant="outlined" onClick={props.onDeselectAll} sizeType="m">
        Deselect All
      </Button>
      {allowLevelFilterList.includes(
        props.filterOption?.columnKey as FEEDBACK_COLUMNS,
      ) && (
        <Dropdown
          menu={{
            items: TopicLevelFilterArr.map((level) => ({
              key: level,
              onClick: () => {
                props.onLevelSelect(level);
              },
              label: <Typo>Level {level}</Typo>,
            })),
          }}
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode as HTMLDivElement;
          }}
        >
          <Flex a="center" style={{ color: color.primary100, padding: 8 }}>
            <Typo>Level filter</Typo>
            <CaretDownOutlined />
          </Flex>
        </Dropdown>
      )}
    </Flex>
  );
};

export default AllSelectFooter;
